import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { LoaderModule } from './../shared/loader/loader.module';
import { AutenticaoGuardService } from './autenticacao-guard';

@NgModule({
  imports: [
    CommonModule,
    LoaderModule
  ],
  declarations: [],
  providers: [
    AutenticacaoService,
    AutenticaoGuardService,
  ]
})
export class SegurancaModule { }
